import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import AdviceFooter from './AdviceFooter';
import { lrnNumber } from '../Content';


const AdviceFooterImpl = ({ noPt }) => {
    const FooterDisc = () => (
        <Box
            id= 'disclosure-container'
        >
            <Typography component="p" type="body" loose scale={200} light style={{ paddingBottom: "12px" }} id="disclosure-copy-risk-1">
                Investments in the <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Retirement Advisory
                Service&trade; are subject to the risks associated with investing in mutual funds and exchange-traded funds, which may result in loss of
                principal. <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> does not guarantee the results of our investment management, or that
                the objectives of the funds or portfolios will be met.
            </Typography>

            <Typography component="p" type="body" loose scale={200} light style={{ paddingBottom: "12px" }} id="disclosure-copy-risk-2">
                Financial planning and retirement income planning in the Retirement Advisory Service involve forward-looking projections that are based upon information
                provided by clients and certain assumptions about future events. Forward-looking projections are based on a limited set of assumptions and actual future
                outcomes may differ significantly from the projections; therefore, they should be used only as an aid for a client&apos;s planning and decision-making and
                not as a guarantee of what will happen in the future.
            </Typography>

            <Typography component="p" type="body" loose scale={200} light style={{ paddingBottom: "12px" }} id="disclosure-copy-discretionary-info">
                The <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Retirement Advisory Service&trade; is a nondiscretionary financial planning and retirement
                income planning service and a discretionary managed account program provided by <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Advisory
                Services, Inc., a registered investment adviser under the Investment Advisers Act of 1940. Brokerage accounts for the Retirement Advisory Service are
                provided by <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Investment Services, Inc., member FINRA/SIPC, and are carried by Pershing LLC, a
                BNY Company, member NYSE/FINRA/SIPC, which acts as a clearing broker for <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Investment
                Services, Inc. <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Advisory Services, Inc.
                and <span style={{ whiteSpace: "nowrap" }}>T. Rowe Price</span> Investment Services, Inc. are affiliated companies.
            </Typography>

            <Typography component="p" type="body" loose scale={200} light style={{ paddingBottom: "12px" }} id="etf-description">
                <strong>ETFs are bought and sold at market prices, not net asset value.</strong> Investors generally incur the cost of the spread between the prices at which shares
                are bought and sold and may incur additional transaction costs.
            </Typography>
            <Typography component="p" type="body" loose scale={200} light id="lrn-number">{lrnNumber}</Typography>
        </Box>
    )
    return (
        <Box sx={{ paddingTop: noPt ? 'inherit' : '64px' }}>
            <AdviceFooter disclosures={<FooterDisc />} copyright='RAS' />
        </Box>
    )
}

export default AdviceFooterImpl;